import Layout from "@/components/layout/Layout";
import { Shield, Award, Users, ThumbsUp, Smile, Heart } from "lucide-react";

const About = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-drivewise-900 to-drivewise-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">About WAY2LEARN DRIVING SCHOOL</h1>
          <p className="text-xl max-w-3xl mx-auto">
            With over 18 years of experience in the driver training industry, WAY2LEARN DRIVING SCHOOL has earned a strong reputation for helping learners become safe, confident, and skilled drivers.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <h2 className="text-3xl font-bold text-road-900 mb-6">Our Mission</h2>
              <p className="text-lg text-road-700 mb-4">
                Our mission is simple: to deliver high-quality, personalised driving tuition that prepares you for life on the road—not just the driving test.
              </p>
              <p className="text-lg text-road-700 mb-4">
                We understand that every learner is different, which is why our fully qualified and highly experienced instructors tailor each lesson to your individual needs, pace, and confidence level. Whether you're a complete beginner, a nervous driver, or someone returning to driving after a break, we're here to support you every step of the way.
              </p>
              <p className="text-lg text-road-700">
                At Way2Learn, we combine patience, professionalism, and a passion for teaching to create a calm, friendly learning environment. Our goal is to make your learning journey enjoyable, effective, and empowering.
              </p>
            </div>
            <div className="md:w-1/2">
              <img 
                src="https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" 
                alt="Way2Learn Driving School" 
                className="rounded-lg shadow-lg w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-road-900 mb-4">Our Values</h2>
            <p className="text-xl text-road-600 max-w-3xl mx-auto">
              These core values guide everything we do at Way2Learn Driving School.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <Shield className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Safety First</h3>
              <p className="text-road-700">
                We prioritize safety in every aspect of our training program. Our instructors emphasize defensive driving techniques and responsible decision-making on the road.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <Users className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Personalized Learning</h3>
              <p className="text-road-700">
                We recognize that each student has unique needs and learning styles. Our approach is tailored to ensure everyone receives the support they need to succeed.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <Award className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Excellence</h3>
              <p className="text-road-700">
                We strive for excellence in everything we do, from the quality of our instruction to the vehicles we use and the learning resources we provide.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <ThumbsUp className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Professionalism</h3>
              <p className="text-road-700">
                Our instructors maintain the highest standards of professionalism, ensuring a respectful and productive learning environment for all students.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <Smile className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Supportive Environment</h3>
              <p className="text-road-700">
                We create a positive, supportive environment where students feel comfortable making mistakes and learning from them.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <Heart className="h-12 w-12 text-drivewise-600 mb-4" />
              <h3 className="text-xl font-bold text-road-900 mb-3">Passion for Teaching</h3>
              <p className="text-road-700">
                Our instructors are passionate about teaching and committed to helping each student achieve their driving goals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-road-900 mb-6">Take the Right Road with WAY2LEARN</h2>
          <p className="text-xl text-road-700 max-w-3xl mx-auto mb-8">
            Drive your future forward with WAY2LEARN DRIVING SCHOOL. Join us on your journey to becoming a confident and skilled driver.
          </p>
          <a
            href="/register"
            className="inline-block bg-drivewise-600 text-white px-8 py-4 rounded-md font-medium hover:bg-drivewise-700 transition-colors"
          >
            Start Your Journey Today
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default About;
